export default {
  API_ENDPOINT: 'https://polar-mesa-07105.herokuapp.com/api',
  TOKEN_KEY: 'spaced-repetition-auth-token'
};
